(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bontex-cart-tier-sync"]) return;
  try {
    
  (() => {
    if (window.bontexCartTierSyncLoaded) return;
    window.bontexCartTierSyncLoaded = true;

    const MIN_QTY = 50;
    const MOQ_TEXT = 'Minimum order: 50 pcs';
    const EMAIL_LINK = 'mailto:Sales@bontex.hk?subject=Order%20smaller%20quantity';
    const EMAIL_TEXT = 'Email us for smaller quantities';
    const DRAWER_SECTION = 'cart-drawer-section';

    const state = {
      productCache: new Map(),
      lastValidQty: new Map(),
      linesByKey: new Map(),
      loading: false,
    };

    const fetchJSON = async (url) => {
      const res = await fetch(url, { credentials: 'same-origin' });
      return res.json();
    };

    const getProduct = async (handle) => {
      if (!state.productCache.has(handle)) {
        try {
          state.productCache.set(handle, await fetchJSON('/products/' + handle + '.js'));
        } catch (e) {
          state.productCache.set(handle, null);
        }
      }
      return state.productCache.get(handle);
    };

    const tierForQty = (variants, qty) => {
      let best = null;
      for (const v of variants || []) {
        const n = parseInt(String(v.title || '').split(/[-+ ]/)[0], 10);
        if (Number.isFinite(n) && n <= qty && (!best || n > best.n)) {
          best = { n, id: String(v.id), title: v.title };
        }
      }
      return best;
    };

    const isTierProduct = (variants) =>
      (variants || []).some((v) => Number.isFinite(parseInt(String(v.title || '').split(/[-+ ]/)[0], 10)));

    const loadCart = async () => {
      const cart = await fetchJSON('/cart.js');
      const lines = [];
      for (const line of cart.items) {
        const product = await getProduct(line.handle);
        lines.push({
          key: line.key,
          product_id: line.product_id,
          handle: line.handle,
          variant_id: String(line.variant_id),
          quantity: line.quantity,
          properties: line.properties || {},
          variants: (product?.variants || []).map((v) => ({ id: String(v.id), title: v.title })),
        });
      }
      state.linesByKey = new Map(lines.map((l) => [l.key, l]));
      for (const line of lines) state.lastValidQty.set(line.key, line.quantity);
      return lines;
    };

    const surface = () => {
      const drawer = document.getElementById('cart-drawer');
      const cartItems = Array.from(document.querySelectorAll('cart-items-component'));
      const pageComp = cartItems.find((c) => !drawer || !drawer.contains(c));
      if (pageComp) return { kind: 'page', sectionId: pageComp.dataset.sectionId || 'cart-section' };
      const drawerComp = cartItems.find((c) => drawer && drawer.contains(c));
      if (drawerComp) return { kind: 'drawer' };
      return null;
    };

    const rerender = async () => {
      const surf = surface();
      if (!surf) return;
      try {
        if (surf.kind === 'page') {
          const data = await fetchJSON('/cart?sections=' + encodeURIComponent(surf.sectionId));
          const html = data[surf.sectionId];
          if (html) {
            const tmp = document.createElement('template');
            tmp.innerHTML = html;
            const next = tmp.content.querySelector('cart-items-component');
            const current = document.querySelector('cart-items-component');
            if (next && current) current.replaceWith(next);
          }
        } else {
          // Side cart: fetch the drawer section in the current page context and hand
          // the HTML to the theme's CartItemsComponent via its update event so it
          // morphs the drawer (per-piece price, line totals, drawer total).
          let resolvePromise;
          const promise = new Promise((resolve) => {
            resolvePromise = resolve;
          });
          const resp = await fetch(
            window.location.pathname + '?section_id=' + encodeURIComponent(DRAWER_SECTION),
            { credentials: 'same-origin' }
          );
          const drawerHtml = await resp.text();
          const sections = {};
          sections[DRAWER_SECTION] = drawerHtml;
          const event = new CustomEvent('shopify:cart:lines-update', {
            detail: { lines: [], action: 'update', sections },
          });
          event.promise = promise;
          document.dispatchEvent(event);
          window.setTimeout(() => resolvePromise({ detail: { sections } }), 50);
        }
      } catch (e) {
        console.error('[Bontex cart sync] rerender failed', e);
      }
    };

    const rowFor = (el) => el?.closest?.('tr[data-key]') || null;
    const inputIn = (row) => row?.querySelector('cart-quantity-selector-component input') || null;

    const showNotice = (row) => {
      if (!row) return;
      const tbody = row.parentElement;
      if (tbody) tbody.querySelectorAll('.bontex-cart-sync__notice-row').forEach((n) => n.remove());
      const noticeRow = document.createElement('tr');
      noticeRow.className = 'bontex-cart-sync__notice-row';
      noticeRow.innerHTML =
        '<td colspan="5" class="bontex-cart-sync__notice">' +
        '<p class="bontex-cart-sync__notice-text">' + MOQ_TEXT + '</p>' +
        '<a class="bontex-cart-sync__notice-cta" href="' + EMAIL_LINK + '">' + EMAIL_TEXT + '</a>' +
        '</td>';
      row.after(noticeRow);
      window.setTimeout(() => noticeRow.remove(), 6000);
    };

    const applyLoading = (row, on) => {
      if (!row) return;
      row.classList.toggle('bontex-cart-sync--loading', on);
      const input = inputIn(row);
      if (input) input.disabled = on;
    };

    const postForm = (url, body) =>
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });

    const propsBody = (props) =>
      Object.entries(props)
        .map(([k, v]) => 'properties[' + k + ']=' + encodeURIComponent(String(v)))
        .join('&');

    // COALESCE + RE-PRICE on the active surface (cart page OR side cart drawer).
    const coalesce = async () => {
      const lines = await loadCart();
      const byProduct = new Map();
      for (const line of lines) {
        if (!byProduct.has(line.product_id)) byProduct.set(line.product_id, []);
        byProduct.get(line.product_id).push(line);
      }
      for (const group of byProduct.values()) {
        if (!group.length) continue;
        const total = group.reduce((sum, l) => sum + l.quantity, 0);
        const target = tierForQty(group[0].variants, total);
        if (!target) continue;
        if (group.length === 1 && target.id === group[0].variant_id) continue;
        const cart = await fetchJSON('/cart.js');
        const indexes = cart.items
          .map((l, idx) => ({ key: l.key, idx: idx + 1 }))
          .filter((x) => group.some((g) => g.key === x.key))
          .map((x) => x.idx)
          .sort((a, b) => b - a);
        for (const idx of indexes) {
          await postForm('/cart/change.js', 'line=' + idx + '&quantity=0');
        }
        const pb = propsBody(group[0].properties);
        const body = 'id=' + target.id + '&quantity=' + total + (pb ? '&' + pb : '');
        await postForm('/cart/add.js', body);
        await rerender();
        return;
      }
    };

    const handleIntent = async (row, input, newQty) => {
      if (!Number.isFinite(newQty) || newQty <= 0) return;
      if (newQty < MIN_QTY) {
        input.value = String(state.lastValidQty.get(row.dataset.key) || MIN_QTY);
        showNotice(row);
        return;
      }
      const lines = await loadCart();
      const line = lines.find((l) => l.key === row.dataset.key);
      if (!line) return;
      const target = tierForQty(line.variants, newQty);
      if (!target) return;
      if (newQty === line.quantity && target.id === line.variant_id) return;
      state.loading = true;
      try {
        if (target.id === line.variant_id) {
          const cart = await fetchJSON('/cart.js');
          const idx = cart.items.findIndex((l) => l.key === line.key) + 1;
          await postForm('/cart/change.js', 'line=' + idx + '&quantity=' + newQty);
          state.lastValidQty.set(line.key, newQty);
        } else {
          const cart = await fetchJSON('/cart.js');
          const idx = cart.items.findIndex((l) => l.key === line.key) + 1;
          await postForm('/cart/change.js', 'line=' + idx + '&quantity=0');
          const pb = propsBody(line.properties);
          const body = 'id=' + target.id + '&quantity=' + newQty + (pb ? '&' + pb : '');
          await postForm('/cart/add.js', body);
          state.lastValidQty.set(line.key, newQty);
        }
        await rerender();
        await coalesce();
      } catch (e) {
        console.error('[Bontex cart sync] change failed', e);
        await rerender();
      }
      state.loading = false;
    };

    const recentlyHandled = new WeakMap();
    const markHandled = (input) => {
      recentlyHandled.set(input, Date.now());
      window.setTimeout(() => {
        if (recentlyHandled.get(input) && Date.now() - recentlyHandled.get(input) > 1200) {
          recentlyHandled.delete(input);
        }
      }, 1300);
    };
    const isRecentlyHandled = (input) => {
      const at = recentlyHandled.get(input);
      return at != null && Date.now() - at < 1200;
    };

    const onWindowEvent = (event) => {
      const target = event.target;
      if (!(target instanceof Element) || !target.isConnected) return;
      const inCartSelector =
        target.closest('cart-quantity-selector-component') || target.matches('cart-quantity-selector-component');
      if (!inCartSelector) return;
      const input = inCartSelector.querySelector('input');
      if (!input) return;
      const row = rowFor(input);
      if (!row) return;
      // Synchronous tier-product check: non-tier products and unknown lines
      // pass through untouched so the theme's native handling always works.
      const cached = state.linesByKey.get(row.dataset.key);
      if (!cached || !isTierProduct(cached.variants)) return;
      if (state.loading || isRecentlyHandled(input)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      let newQty = Number(input.value);
      if (event.type === 'click') {
        const btn = target.closest('button[name="plus"], button[name="minus"]');
        if (btn) newQty += btn.getAttribute('name') === 'plus' ? 1 : -1;
      }
      if (event.type === 'input') return;
      markHandled(input);
      handleIntent(row, input, newQty);
    };

    const sync = async () => {
      if (!surface()) return;
      try {
        await loadCart();
        await coalesce();
      } catch (e) {
        console.error('[Bontex cart sync] sync failed', e);
      }
    };

    ['input', 'change', 'blur', 'click'].forEach((type) => {
      window.addEventListener(type, onWindowEvent, { capture: true });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }

    // Re-sync when the side cart content changes (open / add-to-cart / theme re-render).
    let syncTimer = null;
    const scheduleSync = () => {
      if (syncTimer) window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(sync, 400);
    };
    const drawerEl = document.getElementById('cart-drawer');
    if (drawerEl) {
      const observer = new MutationObserver(scheduleSync);
      observer.observe(drawerEl, { attributes: true, childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
